import { colors, minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery } from '@noths/polaris-client-styles';
import { createGlobalStyle, css } from 'styled-components';

import { MODAL_HEIGHT_CSS_VAR } from '../constants/cssVariables';

export const modalContent = css`
  position: fixed;
  height: 100vh;
  height: var(${MODAL_HEIGHT_CSS_VAR});
  min-height: 100%;
  width: 100%;
  background: #fff;
  top: 0rem;
`;

export interface ModalGlobalStylesProps {
  overlayClassNames: ReactModal.Classes;
  contentClassNames: ReactModal.Classes;
  closeTimeoutMS: number;
}

const SIDEBAR_WIDTH = 60;

export const ModalGlobalStyles = ({
  closeTimeoutMS,
  overlayClassNames,
  contentClassNames,
}: ModalGlobalStylesProps) => createGlobalStyle`
  .ReactModal__Body--open {
    overflow: hidden;
  }

  .${overlayClassNames.base} {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 200;
    transition: opacity ${closeTimeoutMS}ms ease 0s;
    opacity: 0;

    &::before {
      background: ${colors.neutralDarker};
      opacity: 0.2;
      content: '';
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  .${overlayClassNames.afterOpen} {
    opacity: 1;
  }

  .${overlayClassNames.beforeClose} {
    opacity: 0;
  }

  .${contentClassNames.base} {
    left: 0;  
    bottom:0;
    box-sizing: border-box;
    height: 100vh;
    height: var(${MODAL_HEIGHT_CSS_VAR});
    min-height: 100%;
    position: absolute;
    transition: transform ${closeTimeoutMS}ms ease ${closeTimeoutMS}ms;
    width: 100%;
    transform: translateY(100vh);
    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        width: ${SIDEBAR_WIDTH}%;
        transform: translateX(-${SIDEBAR_WIDTH}vw);
      `,
    )}
  }

  .${contentClassNames.afterOpen} {
    transform: translateY(0);
    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        transform: translateX(0);
      `,
    )}
  }

  .${contentClassNames.beforeClose} {
    transform: translateY(100vh);
    transition-delay: 0s;
    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        transform: translateX(-${SIDEBAR_WIDTH}vw);
      `,
    )}
  }
`;
